import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SnackbarService } from '../snackbar/service/snackbar.service';

@Component({
  selector: 'app-modal-config-users',
  templateUrl: './modal-config-users.component.html',
  styleUrls: ['./modal-config-users.component.scss']
})
export class ModalConfigUsersComponent implements OnInit, OnDestroy {

  @Input() open: boolean;
  @Input() users: any[];

  @Output() closeModal: EventEmitter<null> = new EventEmitter();

  constructor(private snack: SnackbarService, private windowService: WindowScrollService) { }

  secondaryMarkety = false;
  primaryMarkety = false;
  location = false;
  sale = false;

  ngOnInit(): void {
    this.windowService.disable();
  }

  ngOnDestroy(): void {
    this.windowService.enable();
  }

  changeActiveStatus(ev, label: string): void {
    this[label] = ev;
    if (label === 'secondaryMarkety' && !ev) {
      this.sale = false;
      this.location = false;
    }
  }

  save() {
    this.snack.show('Sua solicitação está sendo processada.', 'info');
    this.closeModal.emit();
  }

}
